export default __webpack_public_path__ + "static/media/057.9d4d76c9.jpg";